import App from 'models/app';

export const mapPageLayoutItems = (pageLayoutItems, state) =>
  pageLayoutItems.map((item) => {
    if (!item.type.endsWith('APP_LIST')) {
      return item;
    }

    const apps = item.apps.map((app) => App.selectFromState(app.id, state));

    return {
      ...item,
      apps
    };
  });
